export default { sha: '0faa70fcc1ccc8ea06e64ac988d1b9b44c75e1ff', buildNumber: 'undefined' }
